<template>
    <b-button
        v-if="$store.state.isLoggedIn"
        variant="secondary"
        class="fs-sm"
        style="height: 40px"
        @click="logout"
    >
        Odhlásit se
    </b-button>
    <b-dropdown
        v-else
        split
        placement="bottom-end"
        text="Přihlásit se"
        variant="primary"
        split-class="fs-sm"
        style="height: 40px"
        @split-click="openLoginModal"
    >
        <b-dropdown-item-button @click="openRegistrationModal">
            Registrovat se
        </b-dropdown-item-button>
    </b-dropdown>
</template>

<script setup lang="ts">
import authService from '@/api/AuthService';
import { useStore } from 'vuex';

const store = useStore();

async function logout(): Promise<void> {
    await authService.logout();
}

function openLoginModal(): void {
    store.commit('openLoginModal');
}

function openRegistrationModal(): void {
    store.commit('openRegistrationModal');
}
</script>
